import { useLocation } from "react-router-dom";
import { useEffect } from "react";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen gradient-secondary flex items-center justify-center">
      <div className="text-center space-y-8">
        <div className="flex items-center justify-center mb-6">
          <img src="/lovable-uploads/5e002d38-22aa-49af-85ae-34109191ea66.png" alt="AstroPet Logo" className="w-32 h-32" />
        </div>
        <div className="space-y-4">
          <h1 className="text-6xl font-bold gradient-text font-space">404</h1>
          <p className="text-xl text-foreground/80 mb-4">Oops! Pagina non trovata</p>
          <p className="text-lg text-muted-foreground">La pagina che stai cercando sembra essere volata via nell'universo pet.</p>
        </div>
        <a 
          href="/" 
          className="inline-flex items-center px-6 py-3 rounded-lg gradient-primary text-white font-medium hover:scale-105 transition-smooth shadow-primary"
        >
          Torna alla Home
        </a>
      </div>
    </div>
  );
};

export default NotFound;
